import { OSTypes } from '@shared/models/devices/OSTypes';

export function isMac() {
    return navigator.userAgent.toLocaleLowerCase().indexOf('macintosh') > -1;
}

export function isWindows() {
    return navigator.userAgent.toLocaleLowerCase().indexOf('windows') > -1;
}

export function isChromeOS() {
    return navigator.userAgent.toLocaleLowerCase().indexOf('cros') > -1;
}

export function getOS(): OSTypes {
    if (isMac()) {
        return 'MacOS';
    } else if (isWindows()) {
        return 'Windows';
    } else if (isChromeOS()) {
        return 'ChromeOS';
    } else {
        return 'generic';
    }
}
